// extracted by mini-css-extract-plugin
export default {"control":"styles_control__2ANng","control-row":"styles_control-row__2iNQj","slider-row":"styles_slider-row__1O_UR","control-label":"styles_control-label__1927p"};